<script setup>
import { computed } from 'vue';
import { useMessageContext } from '../../provider.js';

import MessageFormatter from 'shared/helpers/MessageFormatter.js';
import { MESSAGE_VARIANTS } from '../../constants';

const props = defineProps({
  content: {
    type: String,
    required: true,
  },
});

// NOTICE: KAPTION-INTEGRATION - isBotPrivateNote is provided by Message.vue context
const { variant, isBotPrivateNote } = useMessageContext();

const formattedContent = computed(() => {
  if (variant.value === MESSAGE_VARIANTS.ACTIVITY) {
    return props.content;
  }

  return new MessageFormatter(props.content).formattedMessage;
});
</script>

<template>
  <span
    v-dompurify-html="formattedContent"
    class="prose prose-bubble"
    :class="[
      {
        'prose-sm [&_p]:!text-[11px] [&_*]:!text-[11px] [&_p]:!text-n-slate-11 [&_*]:!text-n-slate-11 !max-w-none [&_p]:!text-center [&_*]:!text-center':
          isBotPrivateNote,
      },
    ]"
    :style="isBotPrivateNote ? { maxWidth: '100%' } : {}"
  />
</template>
